module.exports = __webpack_public_path__ + "img/italretail.bdbd2c95.jpg";